import React from 'react';
import './Download.css';


const data = [
  

  {
    id: 1,
    title: 'Affidavit Student Scholarship',
    download: '/Admission Form/undertaking Scholarship Declaration YEAR 2025.docx',
  },
  {
    id: 2,
    title: 'Affidavit Student',
    download: '/Admission Form/Affidavit___Student_-2023-1.docx',
  },
  {
    id: 3,
    title: 'Admission Form',
    download: '/Admission Form/164812982088.pdf',
  },
  {
    id: 4,
    title: 'Gap Year Certificate',
    download: '/Admission Form/Gap year Certificate.pdf',
  },
  {
    id: 5,
    title: 'HSBTE 2021-22',
    download: '/Admission Form/EOA Report 21-22.PDF',
  },
  {
    id: 6,
    title: 'HSBTE 2022-23',
    download: '/Admission Form/hsbte technology 2022-23.pdf',
  },
  {
    id: 7,
    title: 'HSBTE 2023-24',
    download: '/Admission Form/HSBTE 2023-24.pdf',
  },
  {
    id: 8,
    title: 'HSBTE 2024-25',
    download: '/Admission Form/HSBTE 2024-25.pdf',
  },
  {
    id: 9,
    title: 'Job Application',
    download: '/Admission Form/165509642338.pdf.pdf',
  },
  {
    id: 10,
    title: 'Prospectus',
    download: '/Admission Form/PTLR Brochure(cut) (4).pdf',
  },
  // {
  //   id: 11,
  //   title: 'SC BC CHECK LIST  25 COLOUM TECHNOLOGY 2025',
  //   download: '/Admission Form/SC BC CHECK LIST  25 COLOUM TECHNOLOGY 2025.xlsx',
  // },
  // {
  //   id: 12,
  //   title: 'SC LIST YEAR 2025 ADMITTED',
  //   download: '/Admission Form/SC LIST YEAR 2025 ADMITTED.xlsx',
  // },
  {
    id: 13,
    title: 'Student Correction',
    download: '/Admission Form/Student Correction Affidavit.pdf',
  },
  {
    id:14,
    title: 'Student Performa',
    download: '/Admission Form/164813022248.pdf',
  },
  {
    id:15,
    title: '25 coloum 2025 PERFORMA',
    download: '/Admission Form/25 coloum 2025 PERFORMA.xlsx',
  },


];

const Download = () => {
  return (
     <div className='main-container-download'>
      <div className='container-download-image'>
        {/* <Slide></Slide> */}
      </div>
      <div className='ab1'>
        <div data-aos='flip-left' data-aos-easing='ease-out-cubic' data-aos-duration='2000'>
          <h1 className='ab1-h1'>Download Form</h1>
          <div className="ab2">
            <table className="ab3">
              <thead>
                <tr>
                  <th>Serial No.</th>
                  <th>Title</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <a
                        href={item.download}
                        download
                        className='ab5'
                      >
                        <span className="ab7">
                          <span className="ab6">Download Now</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
